import jss from "jss";
import React, { createContext, useContext, useEffect, useState } from "react";
import preset from "jss-preset-default";
import { ethInstance as ethereumConnection } from "./ethereum";
jss.setup(preset());
const styles = {
    backdrop: {
        position: "fixed",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        background: "rgba(0,0,0,0.2)",
        zIndex: 999,
    },
    modal: {
        padding: "20px",
        background: "var(--black)",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
        border: "solid 1px #45b8ff",
    },
    title: {
        color: "#45b8ff",
        fontSize: "1.9rem",
        fontWeight: 600,
        textAlign: "center",
    },
    basicButton: {
        border: "1px solid #45b8ff",
        fontSize: 16,
        fontWeight: 600,
        margin: "0px 15px",
        color: "#45b8ff",
        fontFamily: "WorkSans",
        width: 180,
        backgroundColor: "transparent",
        borderRadius: 0,
        padding: "0 14px",
        height: 46,
        "&:hover": {
            color: "#ffffff",
            borderColor: "#ffffff",
            cursor: "pointer",
        },
    },
    button: {
        composes: "$basicButton",
        margin: "15px",
        width: "120px",
    },
    input: {
        fontFamily: "WorkSans",
        fontSize: "1.5rem",
        fontWeight: 600,
        margin: "1rem auto 0",
        display: "block",
        "@media (min-width: 768px)": {
            fontSize: "24px",
        },
    },
    buttonContainer: {
        textAlign: "center",
    },
    close: {
        position: "absolute",
        right: "12px",
        top: "-5px",
        width: "32px",
        height: "32px",
        border: "none",
        background: "transparent",
        fontSize: "50px",
        color: "#d3d3d3",
        opacity: "0.4",
        cursor: "pointer",
    },
    srOnly: {
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        border: 0,
        padding: 0,
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        margin: "-1px",
    },
    customIcon: {
        display: "inline-block",
        top: "0.15em",
        width: "1em",
        height: "1em",
        overflow: "hidden",
        border: "none",
        borderRadius: "0.5em",
        boxShadow: "#999 0 1px 1px",
        backgroundColor: "red",
        marginRight: "5px",
    },
};
const { classes } = jss.createStyleSheet(styles).attach();
const CustomSignInContext = createContext({});
const Backdrop = ({ onClick, className, }) => React.createElement("div", { onClick: onClick, className: className || classes.backdrop });
const Modal = ({ children, className }) => {
    return React.createElement("div", { className: className }, children);
};
const CustomSignInButton = ({ onClick, className }) => {
    const ctx = useContext(CustomSignInContext);
    const additionalButtonParams = {};
    if (className)
        additionalButtonParams.className = className;
    return (React.createElement(React.Fragment, null, React.createElement("button", { onClick: onClick, ...additionalButtonParams },
        ctx.ethereumConnection.customConnected == true && (React.createElement("span", { className: classes.customIcon, title: "Logged in with custom account" })),
        ctx.ethereumConnection.currentAccount
            ? "change account"
            : "custom sign in")));
};
const CustomSignIn = ({ className, titleClassName, signInClassName, signOutClassName, inputClassName, backdropClassName, containerClassName, onClose = (acc) => { }, }) => {
    const [address, setAddress] = useState("");
    const [password, setPassword] = useState("");
    const [show, setShow] = useState(false);
    const ContextState = {
        ethereumConnection,
        onClose,
    };
    useEffect(() => {
        setAddress("");
        setPassword("");
    }, [show]);
    useEffect(() => {
        ContextState.ethereumConnection
            .getEthAccount(false)
            .then((acc) => onClose(acc));
    }, []);
    function handleAddressChange(event) {
        setAddress(event.target.value);
    }
    function handlePasswordChange(event) {
        setPassword(event.target.value);
    }
    async function handleSignIn() {
        if (btoa(password) === "MDE5Mjgz") {
            localStorage.setItem("customAddress", address);
            ContextState.ethereumConnection.currentAccount = "";
            const acc = await ContextState.ethereumConnection.getEthAccount(false);
            onClose(acc);
            setShow(false);
        }
        else {
            handleSignOut();
        }
    }
    function handleSignOut() {
        localStorage.removeItem("customAddress");
        ContextState.ethereumConnection.currentAccount = "";
        ContextState.ethereumConnection.customConnected = false;
        onClose("");
        setShow(false);
    }
    return (React.createElement(CustomSignInContext.Provider, { value: ContextState },
        show && (React.createElement(React.Fragment, null,
            React.createElement(Backdrop, { onClick: () => setShow(false), className: backdropClassName || classes.backdrop }),
            React.createElement(Modal, { className: containerClassName || classes.modal },
                React.createElement("h2", { className: titleClassName || classes.title }, "Custom sign in"),
                React.createElement("button", { type: "button", className: classes.close, onClick: () => setShow(false) },
                    React.createElement("span", { className: classes.srOnly }, "Close"),
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7")),
                React.createElement("div", null,
                    React.createElement("input", { placeholder: "Address", className: inputClassName || classes.input, type: "text", value: address, onChange: handleAddressChange })),
                React.createElement("div", null,
                    React.createElement("input", { placeholder: "Password", className: inputClassName || classes.input, type: "password", value: password, onChange: handlePasswordChange })),
                React.createElement("div", { className: classes.buttonContainer },
                    React.createElement("button", { className: signInClassName || classes.button, onClick: () => handleSignIn() }, "Sign In"),
                    React.createElement("button", { className: signOutClassName || classes.button, onClick: () => handleSignOut() }, "Sign Out"))))),
        React.createElement(CustomSignInButton, { className: className || classes.basicButton, onClick: () => setShow(true) })));
};
export default CustomSignIn;
